import React, { useEffect } from 'react';
import './UsersPage.scss';
import Sidebar from '../../components/Sidebar/Sidebar';
import P4STable from '../../components/P4STable/P4STable';
import { columns, tableSetting, addParams, editParams } from './consts';
import { useDispatch, connect } from 'react-redux';
import {
    requestGetUsersList,
    requestAddUser,
    requestDeleteUser,
    requestEditUser,
    clearUserError,
} from '../../store/users/actions';
import { getUsersList, getError } from '../../store/users/selectors';
import { AppState } from '../../store/rootReducer';
import { UsersPageProps } from './types';
import { User } from '../../store/users/types';
import SnackbarMessage from '../../components/SnackbarMessage/SnackbarMessage';
import UserRoles from '../../resources/enums/UserRoles';

const UsersPage: React.FC<UsersPageProps> = (props) => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(requestGetUsersList([UserRoles.Admin, UserRoles.SuperAdmin, UserRoles.Coach]));
    }, []);

    addParams.handleSubmit = (data: object, setOpen: React.Dispatch<React.SetStateAction<boolean>>) => {
        dispatch(requestAddUser(data as User));
        setOpen(false);
    };

    editParams.handleSubmit = (data: object, setOpen: React.Dispatch<React.SetStateAction<boolean>>) => {
        const editData = data as { uid: string; role: string };
        dispatch(requestEditUser(editData.uid, editData.role));
        setOpen(false);
    };

    tableSetting.handleDelete = (uid: string) => {
        dispatch(requestDeleteUser(uid));
    };
    return (
        <div>
            <Sidebar></Sidebar>
            <P4STable
                data={props.users}
                columns={columns}
                orderBy={tableSetting.orderBy}
                filterBy={tableSetting.filterBy}
                rowsPerPage={tableSetting.rowsPerPage}
                pages={tableSetting.pages}
                order={tableSetting.orderDirection}
                handleDelete={tableSetting.handleDelete}
                addParams={addParams}
                editParams={editParams}
            ></P4STable>
            <SnackbarMessage
                serverity="error"
                message={props.error}
                clearMessage={() => {
                    dispatch(clearUserError());
                }}
            ></SnackbarMessage>
        </div>
    );
};

function mapStateToProps(state: AppState) {
    return {
        users: getUsersList(state),
        error: getError(state),
    };
}

export default connect(mapStateToProps)(UsersPage);
